module.exports = __webpack_public_path__ + "static/img/nl.09f3280d.svg";